/**
 * --keyboard-inset: clientHeight − visualViewport.height − offsetTop.
 * 100dvh на iOS врёт, когда открыта клавиатура.
 */

let bound = false;

function writeInset(): void {
  const vv = window.visualViewport;
  const root = document.documentElement;
  if (vv == null) {
    root.style.setProperty('--keyboard-inset', '0px');
    return;
  }
  const inset = Math.max(0, window.innerHeight - vv.height - vv.offsetTop);
  root.style.setProperty('--keyboard-inset', `${Math.round(inset)}px`);
}

export function bindViewport(): void {
  if (bound) return;
  bound = true;
  writeInset();
  const vv = window.visualViewport;
  vv?.addEventListener('resize', writeInset);
  vv?.addEventListener('scroll', writeInset);
  window.addEventListener('resize', writeInset);
}

export function unbindViewport(): void {
  if (!bound) return;
  bound = false;
  const vv = window.visualViewport;
  vv?.removeEventListener('resize', writeInset);
  vv?.removeEventListener('scroll', writeInset);
  window.removeEventListener('resize', writeInset);
  document.documentElement.style.removeProperty('--keyboard-inset');
}

export function keyboardInset(): number {
  const raw = getComputedStyle(document.documentElement).getPropertyValue('--keyboard-inset');
  const n = Number.parseFloat(raw);
  return Number.isFinite(n) ? n : 0;
}
